import {
  AssistantPhoneNumberRecordModel,
  AssistantPhoneNumberListModel,
  AssistantPhoneNumberCompactModel,
  AssistantPhoneNumberEvenCompactModel,
} from "../models";
import {
  GetPhoneNumberList200,
  GetPhoneNumberListParams,
  PhoneNumberInfo,
  PhoneNumberWithSid,
} from "../services";
import {ManagementTransformBase} from "./TranformBase";

import {Assistant} from "@/api/services";

export class PhoneNumbersTransform extends ManagementTransformBase<AssistantPhoneNumberRecordModel> {
  public makeCompactModel(dto: Assistant): AssistantPhoneNumberCompactModel {
    const model: AssistantPhoneNumberCompactModel = {
      value: dto.phone_number,
      sid: dto.phone_number_sid,
    };

    return model;
  }

  public makeEvenCompactModel(
    dto: Assistant,
  ): AssistantPhoneNumberEvenCompactModel {
    return {value: dto.phone_number};
  }

  public makeRecordModel(
    dto: PhoneNumberWithSid,
  ): AssistantPhoneNumberRecordModel {
    const model: AssistantPhoneNumberRecordModel = {
      sid: dto.phone_number_sid,
      value: dto.phone_number,
    };

    return model;
  }

  public makeListModel(
    dto: GetPhoneNumberList200,
  ): AssistantPhoneNumberListModel {
    const model: AssistantPhoneNumberListModel = {
      records: dto.items.map(item =>
        this.makeRecordModel(item as PhoneNumberInfo),
      ),
      pagination: this.makePaginationModel({
        page_number: dto?.page_number,
        page_size: dto?.page_size,
        total: dto?.total,
        items: dto.items as unknown[],
      }),
    };

    return model;
  }

  public makeGetDto(model: {
    workspaceId: string;
    pageIndex?: number;
    pageSize?: number;
    search?: string;
  }): GetPhoneNumberListParams {
    const data: GetPhoneNumberListParams = {
      workspace_id: model.workspaceId,
      page_number: model.pageIndex + 1 || 1,
      page_size: model.pageSize || 50,
      search: model.search || undefined,
    };

    return data;
  }
}

export const phoneNumbersTransform = new PhoneNumbersTransform();
